"use strict";

var toInteger = require("./to-integer")

  , max = Math.max;

module.exports = function (value) {
 return max(0, toInteger(value));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/number/to-pos-integer.js
// module id = 68
// module chunks = 0